export default {
  paused: 'Los pagos en línea están pausados por problemas de verificación KYC.',
  deadline_warning: 'Se requiere verificación KYC; de lo contrario, los pagos en línea se pausarán el {{date}}.',
  complete_verification: 'Completar verificación',
  partner: {
    action_needed:
      'Tu proveedor de pagos necesita un dato más antes de que este restaurante pueda aceptar pagos en línea.',
    hosted_incomplete: 'Aún no has terminado de configurar los pagos en línea con tu proveedor de pagos.',
    link_expired: 'Tu enlace para terminar de configurar los pagos en línea ha caducado. Obtén uno nuevo y continúa.',
    open_error: 'No se pudo contactar al proveedor de pagos. Inténtalo de nuevo en unos minutos.',
    hosted_not_started: 'Los pagos en línea aún no están configurados con tu proveedor de pagos.',
    business_details_missing: 'Agrega los datos de tu empresa para empezar a recibir pagos en línea.',
    continue: 'Continuar',
  },
};
